/**
=========================================================
* Vue Soft UI Dashboard PRO - v3.0.0
=========================================================
* Product Page: https://creative-tim.com/product/vue-soft-ui-dashboard-pro
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
Coded by www.creative-tim.com
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import "./assets/js/nav-pills.js";
import "./assets/scss/soft-ui-dashboard.scss";

export default {
  // eslint-disable-next-line prettier/prettier
  install() {}
};
